import { COVERGO_CA_UAT, COVERGO_SAAS_DEV, COVERGO_ASIA_QA } from "../consts.js"

export const presales_c2_uat = {
	"presales-c2-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "presales_c2_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-presales-c2-uat"
		}
	},
}
export const presale_dev = {
	"presale-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "presale_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-presale-dev"
		}
	},
}

export const presales = {
	"presales-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "presales",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-presales"
		},
	},
}
